<template>
  <div class="container">
    <div class="row mt-3">
      <div class="col">
        <label for=""
               class="label">
          Status
        </label>
        <v-select :id="`regime_bens_${ _uid }`"
                  v-model="busca.status"
                  :reduce="status => status.value"
                  class="form-control form-control-sm"
                  :options="select.status" />
      </div>
      <div class="col">
        <label for=""
               class="label">
          Tipo de data
        </label>
        <v-select :id="`tipo_data_${ _uid }`"
                  v-model="busca.tipo_data"
                  :reduce="status => status.value"
                  class="form-control form-control-sm"
                  :options="select.tipo_data" />
      </div>
      <div v-if="busca.tipo_data != null"
           class="col-6">
        <label for=""
               class="label">
          Data
        </label>
        <div class="row no-gutters">
          <div class="col">
            <input v-model="busca.data_inicial"
                   type="date"
                   class="form-control form-control-sm"
                   @keyup.enter="buscarTarefas()">
          </div>
          <div class="col-1 ml-3 no-padding">
            até
          </div>
          <div class="col">
            <input v-model="busca.data_final"
                   type="date"
                   class="form-control form-control-sm"
                   @keyup.enter="buscarTarefas()">
          </div>
        </div>
      </div>
      <div v-else
           class="col-6" />
    </div>

    <div class="row mt-2">
      <div class="col-5">
        <label for=""
               class="label">
          Número da matrícula
        </label>
        <input v-model="busca.matricula"
               v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
               type="text"
               class="form-control form-control-sm"
               @keyup.enter="buscarTarefas()">
      </div>
      <div class="col">
        <label for=""
               class="label">
          Nome do registrado
        </label>
        <input v-model="busca.nome_registrado"
               type="text"
               class="form-control form-control-sm"
               @keyup.enter="buscarTarefas()">
      </div>
    </div>
    <!--
    <div class="row mt-2">

      <div class="col-6">
        <box-tipo v-model="busca.tipo"
                  :prop-options="tipos"
                  :prop-header-blue="true"
                  :prop-tipo-registro="busca.tipo" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="GerenciadorBusca--borderBlue">
          <div class="row p-2">
            <div class="col-6">
              <v-select v-model="busca.acao"
                        :options="optionsServicos()"
                        :reduce="servico => servico.value"
                        class="form-control form-control-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    -->
    <div class="row my-3">
      <div class="col-10 col-sm-10">
        <div class="row no-gutters">
          <div class="col-md-3 col-sm-1">
            <label for=""
                   class="label">
              Tipo de registro:
            </label>
          </div>
          <div class="col-9">
            <div class="row">
              <b-form-checkbox
                :id="`filtro_todos_${ _uid }`"
                :name="`filtro_todos_${ _uid }`"
                value="accepted"
                class="col-2"
                unchecked-value="not_accepted">
                Todos
              </b-form-checkbox>

              <b-form-checkbox
                :id="`filtro_nascimento_${ _uid }`"
                v-model="busca.tipo_registro"
                :name="`filtro_nascimento_${ _uid }`"
                value="N"
                class="col-3"
                unchecked-value="not_accepted">
                <icon-svg icon="nascimento"
                          class="icon--sm"
                          style="float: left" />
                Nascimento
              </b-form-checkbox>

              <b-form-checkbox
                :id="`filtro_casamento_${ _uid }`"
                v-model="busca.tipo_registro"
                :name="`filtro_casamento_${ _uid }`"
                value="C"
                class="col-3"
                unchecked-value="not_accepted">
                <icon-svg icon="engagement"
                          class="icon--sm"
                          style="float: left" />
                Casamento
              </b-form-checkbox>

              <b-form-checkbox
                :id="`filtro_obito_${ _uid }`"
                v-model="busca.tipo_registro"
                :name="`filtro_obito_${ _uid }`"
                value="O"
                class="col-3"
                unchecked-value="not_accepted">
                <icon-svg icon="flower"
                          class="icon--sm"
                          style="float: left" />
                Óbito
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1 text-right">
        <button class="btn btn-sm btn-primary px-4"
                @click="buscarTarefas(true)">
          Filtrar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import BoxTipo from "@/components/SofiaRei/BoxTipo"

  /* constants */
  import { tipos, acoes } from "@/constants/gerenciador"

  /* services */
  import GerenciadorService from "@/services/GerenciadorService"

  /* others */
  import { mapGetters } from "vuex"

  export default {
    name: "GerenciadorBusca",
    components: {
      BoxTipo
    },
    props: ["propPagination", "propOrder"],
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    data () {
      return {
        tipos,
        acoes,
        busca: {
          acao: null,
          status: null,
          tipo_data: null,
          data_inicial: null,
          data_final: null,
          matricula: null,
          nome_registrado: null,
          orderBy: "data_inclusao",
          tipo_registro: ['N', 'C', 'O'],
          tipo: "CARGA"
        },
        select: {
          status: [
            { value: null, label: 'Todas não cumpridas' },
            { value: 'VENCIDA', label: 'Vencidas' },
            { value: 'A_VENCER', label: 'A vencer' },
            { value: 'PENDENTE_ERRO', label: 'Pendentes com erro' },
            { value: 'CUMPRIDA', label: 'Todas cumpridas' }
          ],
          tipo_data: [
            {
              label: 'Qualquer data',
              value: null
            },
            {
              label: 'Data Inclusão',
              value: 'data_inclusao'
            },
            {
              label: 'Data Registro',
              value: 'data_registro'
            },
            {
              label: 'Data Cumprimento',
              value: 'data_cumprimento'
            },
            {
              label: 'Data máxima cumprimento',
              value: 'data_max_cumprimento'
            }
          ]
        }
      }
    },
    watch: {
      'propPagination.page' () {
        this.buscarTarefas()
      },
      'propPagination.perPage' () {
        this.buscarTarefas()
      },
      'propOrder' () {
        this.buscarTarefas()
      },
    },
    methods: {
      optionsServicos () {
        return acoes.filter(acao => acao.belongs.indexOf(this.busca.tipo) != -1 && !!acao.show)
      },
      clearSpaces (value) {
        return value && value.replace(/ /g, '') || value
      },
      async buscarTarefas (click = false) {
        try {
          if (click) {
            this.$emit('onSearch')
          }

          loader({ text: 'Buscando tarefas...', active: true })
          Object.assign(this.busca, Object.assign(this.propPagination, (click ? { page: 1 } : {})), { cartorio_id: this.$store.state.auth.cartorio_id }, { orderBy: this.propOrder }, { matricula: this.clearSpaces(this.busca.matricula) })
          const data = await GerenciadorService.getTarefas(this.busca)
          this.$emit('onGetTarefas', data)
        } finally {
          loader({ active: false })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../scss/_utilities/_exports";

  .GerenciadorBusca {
    &--checkboxFiltro {
      float: left;
      margin-right: 1em;
    }
    &--borderBlue {
      border: 4px solid $sinoreg-blue;
    }
  }
</style>
